import React from "react";

import cont1 from "../../../images/contactimage/cont1.jpeg"
const BottomContactSection2 = () => {
  return (
    <div className="mx-5 flex flex-col mt-20 lg:mt-40">
      <div className=" lg:w-[90%] relative flex flex-col justify-evenly items-center lg:block   ">
        <div className="lg:w-[50%]  float-right">
          <img
            className="lg:w-full lg:h-[38rem]"
            src={cont1}
            alt=""
          />
        </div>
        <div className="lg:absolute  top-16 left-36   ">
          <div className="lg:float-left lg:w-[58%]   bg-white pb-10 lg:shadow-md lg:shadow-slate-400">
            <div className="mx-5">
              <h1 className="mt-11 text-5xl font-bold">SUCCESS FORMULA</h1>
              <br />
              <h2 className="mt-4 text-2xl font-bold text-gray-700">
                ||||||||||||||||||
                <br />
                |||||||||||||||||||||||||||||||| “Do the best you can. ...
              </h2>
              <p className="mt-8 text-xl leading-8 text-justify">
                Believe in yourself and believe in your goal, show your
                commitment, be an optimist, solve problems, follow your dreams,
                live with integrity, Show your passion and push yourself.
              </p>
              <button className="mt-10 cursor-pointer bg-blue-400 px-8 py-5 text-xl font-semibold text-black hover:bg-black hover:text-white">
                Success = Ability x Effort x Attitude
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomContactSection2;
